export const itemsMessages = {
  createSuccess: 'The item was created successfully.',
  updateSuccess: 'The item was updated successfully.',
  createQuestionSuccess: 'Your question was created successfully.',
  publishAnswerStackSuccess: 'The answer stack was published successfully.',
  unPublishAnswerStackSuccess: 'The answer stack was un-published successfully.',
  publishAllSuccess: 'All items were published successfully.',
  promoteAnswerStackSuccess: 'The item was moved to the JA USA item bank successfully.',
};
